module.exports = __webpack_public_path__ + "img/match--type1_img5.d07fd314.png";